export default __webpack_public_path__ + "a12d0b83de3e7a2c348cb1612a741ca5.gif";